// extracted by mini-css-extract-plugin
export var container = "_jm-0";
export var dotAnimation = "_jm-2";
export var dotsLoading = "_jm-1";